import React from 'react';
import { Section } from '@/pages/LandingComplete';
import SectionHeader from './SectionHeader';
import { Card, CardContent } from '@/components/ui/card';
import { Clock } from 'lucide-react';

interface TimesContent {
  title?: string;
  titleHighlight?: string;
  subtitle?: string;
  slots?: Array<{
    day: string;
    time: string;
  }>;
  note?: string;
}

export function DynamicTimes({ content }: { content: TimesContent }) {
  const slots = content.slots || [];

  return (
    <Section id="zeiten" alternate>
      <SectionHeader 
        number="03" 
        title={content.title || "Arbeitszeiten &"} 
        highlight={content.titleHighlight || "Verfügbarkeit"}
        centered={false}
      />
      
      <div className="grid items-center gap-16 lg:grid-cols-2">
        <div>
          {content.subtitle && (
            <p className="text-xl text-muted-foreground leading-relaxed mb-8">
              {content.subtitle}
            </p>
          )}
          
          <div className="space-y-6">
            {slots.map((slot, i) => (
              <div key={i} className="flex items-start gap-4 p-4 rounded-xl bg-slate-50 border border-slate-100 transition-all hover:shadow-md hover:bg-white">
                <div className="p-2 rounded-full bg-[--brand-primary]/10">
                  <Clock size={18} className="text-[--brand-primary]" />
                </div>
                <span className="text-slate-700 leading-relaxed font-medium">
                  <strong>{slot.day}:</strong> {slot.time}
                </span>
              </div>
            ))}
          </div>
          
          {content.note && (
            <p className="mt-6 text-muted-foreground italic">{content.note}</p>
          )}
        </div>
        
        <div className="relative">
          <div className="absolute -top-8 -right-8 w-64 h-64 bg-gradient-to-br from-blue-200/30 to-indigo-200/30 rounded-full blur-3xl"></div>
          
          <Card className="overflow-hidden border-0 shadow-2xl ring-1 ring-slate-200/60 rounded-3xl relative z-10 transform hover:scale-105 transition-transform duration-500">
            <CardContent className="p-0 relative">
              <div className="absolute top-6 right-6 z-10">
                <div className="bg-white/90 backdrop-blur-sm rounded-xl px-4 py-2 shadow-lg">
                  <div className="flex items-center gap-2 text-sm font-semibold text-slate-700">
                    <div className="w-2 h-2 rounded-full bg-green-500 animate-pulse"></div>
                    Mo-Fr 8:00-17:00
                  </div>
                </div>
              </div>
              <img 
                src="https://images.unsplash.com/photo-1573164713714-d95e436ab8d6" 
                alt="Remote Support Arbeitsplatz" 
                className="h-96 w-full object-cover" 
              />
            </CardContent>
          </Card>
        </div>
      </div>
    </Section>
  );
}
